import axios from 'axios'

export default {
  getMyEnvelopes: function (mnemo, queryObject = {}) {
    return axios.get(`/room/${mnemo}/myEnvelopes`, { params: queryObject })
  },
}
